import React from 'react';
import { getOpenCardFaceBgClasses, getOpenCardFaceStyle } from '../utils/openCardFace';

const OpenCardFaceBackground = ({
  mainColor,
  cardStyle,
  backgroundPattern,
  gradientColor,
  gradientAngle,
}) => (
  <div
    className={getOpenCardFaceBgClasses({ cardStyle, backgroundPattern })}
    style={getOpenCardFaceStyle({
      mainColor,
      backgroundPattern,
      gradientColor,
      gradientAngle,
    })}
    aria-hidden="true"
  />
);

export default OpenCardFaceBackground;
